"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolNetworkResolver = void 0;
var CommonSolUtilsConfig_1 = require("./config/CommonSolUtilsConfig");
var dataTypes_1 = require("./dataTypes");
var SolNetworkResolver = /** @class */ (function () {
    function SolNetworkResolver() {
    }
    SolNetworkResolver.resolve = function (network, core) {
        if (!network) {
            network = core.config.get(CommonSolUtilsConfig_1.CommonSolUtilsConfig.defaultSolNetwork);
        }
        return dataTypes_1.SolNetwork.create(network).network;
    };
    return SolNetworkResolver;
}());
exports.SolNetworkResolver = SolNetworkResolver;
//# sourceMappingURL=SolNetworkResolver.js.map